import { Pill, type PillTone } from "../../components/ui/Pill";
import { RUN_STATUSES, type RunStatus } from "../../api/types/onboardingRun";

// Pill has no "busy" tone; in-flight (claimed/running) uses warn, gated/pre-run
// states use info, draft/cancelled neutral, terminal ok/crit.
const TONES: Record<RunStatus, PillTone> = {
  draft: "neutral",
  previewed: "info",
  approved: "info",
  queued: "info",
  claimed: "warn",
  running: "warn",
  succeeded: "ok",
  failed: "crit",
  cancelled: "neutral",
  needs_reconciliation: "crit",
};

const LABELS: Record<RunStatus, string> = Object.fromEntries(
  RUN_STATUSES.map((s) => [s.value, s.label]),
) as Record<RunStatus, string>;

export function StatusBadge({ status }: { status: RunStatus }) {
  return <Pill tone={TONES[status]}>{LABELS[status] ?? status}</Pill>;
}
